__turbopack_context__.v({
  "discountSignal": "DiscountSignal-module-scss-module__6Rkbwq__discountSignal",
});
